import React from 'react';
import styles from './JoyRide.module.less';

interface EventObject {
  condition: () => boolean;
  func: () => any;
}

export interface Props {
  queue: EventObject[];
  children: any;
}

export const JoyRide: React.FunctionComponent<Props> = ({
  queue,
  children,
}) => {
  const [queueIndex, setQueueIndex] = React.useState(0);

  /**
   * Checks if all events have been set to listeners
   * @returns {boolean}
   */
  const isDone = () => queue.length - 1 < queueIndex;

  /**
   * Checks if condition for current index is met
   * @returns {*}
   */
  const currentConditionMet = () => queue[queueIndex]?.condition();

  /**
   * Check if next event is ready to be set up
   * @returns {*|boolean}
   */
  const nextEventReady = () => !isDone() && currentConditionMet();

  /**
   * Set check for fired event and run event
   */
  const runQueueFunction = () => {
    if (nextEventReady()) {
      queue[queueIndex].func();
      setQueueIndex(queueIndex + 1);
    }
  };

  return (
    <div className={styles.JoyRide} onPointerDown={runQueueFunction}>
      {children}
    </div>
  );
};

export default JoyRide;
